export default {
  ProductAuditStrategy: {
    top: {
      SKUreview: 'SKU Information Review',
      Create: 'Enable Review When Creating SKU',
      Modify: 'Enable Review When Modifying SKU',
      Trigger: 'Trigger Review Conditions',
      price: 'SKU Price Changes',
      attribute: 'SKU Attribute Changes',
    },
    middle: {
      synchronization: 'SKU Information Synchronization',
      information: 'Synchronize Product Information to Third-Party',
      classification: 'Synchronize Product Categories to Third-Party',
    },
    bottom: {
      shelf: 'Review for Product Listing and Delisting',
      Open: 'Enable',
      select: 'Please select a trigger approval condition',
      Whether: 'Whether to save the current operation ?',
    }
  },
};
